(function ($) {

    let formObj;

    /**
     * ClosedSynthesisSchool
     *
     * @param options
     * @constructor
     */
    function ClosedSynthesisSchool(options) {
        if (!options) {
            throw new Error('No options passed to ClosedSynthesisSchool constructor');
        } else if (!options.apiHost) {
            throw new Error('No apiHost passed to ClosedSynthesisSchool constructor');
        } else if (!options.nonce) {
            throw new Error('No nonce passed to ClosedSynthesisSchool constructor');
        } else if (!options.smartCaptchaClientKey) {
            throw new Error('No smartCaptchaClientKey passed to ClosedSynthesisSchool constructor');
        } else if (!options.isDebug) {
            throw new Error('No isDebug passed to ClosedSynthesisSchool constructor');
        }
        this.options = $.extend({}, ClosedSynthesisSchool.defaults, options);

        this.setup();
    }

    /**
     * Setup events
     */
    ClosedSynthesisSchool.prototype.setup = function () {
        let self = this;
        self.initSmartCaptcha();

        $('.sbs-checkbox').on('change', function () {
            if ($(this).is(':checked')) {
                $(this).closest('.custom-checkbox').find('.engineer-checkbox').removeClass('bad-validation');
            }
        });
    }

    /**
     * Yandex Smart captcha initialization and form submit handler
     */
    ClosedSynthesisSchool.prototype.initSmartCaptcha = function () {
        let self = this;

        const forms = document.querySelectorAll('.subscribe-closed');

        forms.forEach((form) => {
            const captchaContainer = form.querySelector('.captcha-container');
            const captchaID = window.smartCaptcha.render(captchaContainer, {
                sitekey: this.options.smartCaptchaClientKey,
                invisible: (typeof this.options.isDebug === 'undefined' || this.options.isDebug === 'false'),
                test: (typeof this.options.isDebug !== 'undefined' && this.options.isDebug === true),
                callback: (token) => {
                    self.sendFormData(form, token);
                    window.smartCaptcha.reset(captchaID);
                },
            });

            form.onsubmit = (event) => {
                event.preventDefault();

                if (!self.validate(form)) {
                    return;
                }
                self.formObj = $(event.target);

                window.smartCaptcha.execute(captchaID);
            }
        })
    }

    /**
     * Send data to server
     *
     * @param form
     * @param token
     */
    ClosedSynthesisSchool.prototype.sendFormData = function (form, token) {
        let data = {
            email: form.querySelector('input[type="email"]').value,
            recaptcha_token: token
        }

        this.send(data);
    }

    /**
     * Validate form
     *
     * @param formObj
     * @returns {boolean}
     */
    ClosedSynthesisSchool.prototype.validate = function (formObj) {
        const customCheckBox = formObj.querySelector('.engineer-checkbox');
        const hiddenCheckBox = formObj.querySelector('.sbs-checkbox');

        if (!hiddenCheckBox.checked) {
            customCheckBox.classList.add('bad-validation');
            return false;
        }
        customCheckBox.classList.remove('bad-validation');
        return true;
    }

    /**
     * Send form data to server
     */
    ClosedSynthesisSchool.prototype.send = function (data) {
        const self = this;

        $.ajax({
            type: 'post',
            url: self.options.apiHost,
            data: data,
            dataType: 'json',
            beforeSend: function (xhr) {
                xhr.setRequestHeader('X-WP-Nonce', self.options.nonce);
                self.disableInputs();
            },
            success: function (response) {
                self.showModal(true);
                self.eraseForm();
                self.enableInputs();
            },
            error: function (data) {
                self.enableInputs();
                self.showModal(false);
            }
        });
    }


    /**
     * Disable form inputs
     */
    ClosedSynthesisSchool.prototype.disableInputs = function () {
        this.formObj.find('input, button').prop('disabled', true);
    }

    /**
     * Enable form inputs
     */
    ClosedSynthesisSchool.prototype.enableInputs = function () {
        this.formObj.find('input, button').prop('disabled', false);
    }

    /**
     * Erase all form data
     */
    ClosedSynthesisSchool.prototype.eraseForm = function () {
        this.formObj.find('input[type="email"]').val('');
        this.formObj.find('input[type="checkbox"], input[type="radio"]').prop('checked', false);
    }

    /**
     * Show modal with messages
     *
     * @param success
     */
    ClosedSynthesisSchool.prototype.showModal = function (success) {
        if (success) {
            jQuery.fancybox.open('<div class="content-response _success"><div class="content-response-inner"><h2 class="content-response-title _success">Успешно отправлено</h2><p>Спасибо за проявленный интерес и&nbsp;подписку.</p><p>Иногда наши письма попадают в&nbsp;«Спам». Обнаружив их&nbsp;там, перенеси во&nbsp;«Входящие», чтобы&nbsp;новые письма не&nbsp;потерялись.</p></div></div>');
        } else {
            jQuery.fancybox.open('<div class="content-response _success"><div class="content-response-inner"><h2 class="content-response-title _error">Что-то пошло не&nbsp;так</h2><p>Отправьте письмо на <a href="mailto:synthesis@yadro.com">synthesis@yadro.com</a></p></div></div>');
        }
    }

    window.ClosedSynthesisSchool = ClosedSynthesisSchool;

})(jQuery);
